import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomurudeshwarbusonrent() {



  const cardData =
  {
    keyword: 'Pune to Murudeshwar Bus On Rent Service',
    heading: 'Sanavi Travels: Pune to Murudeshwar Bus On Rent Service',
    headingDescription: 'Sanavi Travels offers Pune to Murudeshwar Bus On Rent Service, providing safe, comfortable, and well-organized transportation for families, groups, pilgrims, and coastal tour travelers. Our fleet of well-maintained AC and Non-AC buses, mini buses, and luxury coaches ensures spacious seating, smooth long-distance travel, and ample luggage space for a hassle-free journey. With experienced drivers, flexible one-way and round-trip bus rental options, transparent pricing, and 24/7 booking support, we guarantee punctual and stress-free travel from Pune to Murudeshwar. Choose Sanavi Travels for reliable Pune to Murudeshwar bus rental services, delivering comfort, safety, and convenience for a memorable coastal travel experience.',

    top: 'Top Places to Visit in Murudeshwar with Sanavi Travels',


"topPlaces": [
  {
    "title": "Murudeshwar Shiva Temple",
    "description": "The Murudeshwar Shiva Temple is a famous coastal pilgrimage site in Karnataka, dedicated to Lord Shiva. It is uniquely located on the shores of the Arabian Sea, creating a breathtaking spiritual and scenic atmosphere. The temple is closely associated with the legend of the Atma Linga of Lord Shiva. Devotees believe that worshipping here brings peace, strength, and divine blessings. The sound of ocean waves combined with temple chants creates a deeply calming and powerful spiritual experience."
  },
  {
    "title": "Murudeshwar Shiva Statue",
    "description": "The towering statue of Lord Shiva in Murudeshwar is one of the tallest Shiva statues in the world. Standing majestically against the backdrop of the sea, the statue depicts Lord Shiva in a meditative pose, symbolizing supreme consciousness and calm. The statue has become an iconic landmark and a major attraction for pilgrims, photographers, and tourists visiting the region."
  },
  {
    "title": "Gopuram and Raja Gopura Viewpoint",
    "description": "The Murudeshwar temple complex features a tall Raja Gopura (temple tower) equipped with an elevator that takes visitors to the top. From the viewpoint, visitors can enjoy panoramic views of the Arabian Sea, temple complex, Shiva statue, and surrounding coastline. Sunrise and sunset views from the tower are especially mesmerizing."
  },
  {
    "title": "Murudeshwar Beach",
    "description": "Murudeshwar Beach stretches along the temple complex and offers clean sands, gentle waves, and scenic beauty. Visitors can relax, take peaceful walks, and enjoy the refreshing sea breeze. The beach is also popular for watching sunsets, making it a perfect blend of spirituality and leisure."
  },
  {
    "title": "Atma Linga Legend Site",
    "description": "Murudeshwar is deeply connected to the legend of Ravana and the Atma Linga of Lord Shiva. According to mythology, a part of the Atma Linga fell here, making the site highly sacred. The temple architecture and rituals reflect this powerful mythological significance."
  },
  {
    "title": "Netrani Island (Nearby)",
    "description": "Located off the coast near Murudeshwar, Netrani Island is a popular destination for scuba diving and snorkeling. Known for its clear waters and vibrant marine life, the island attracts adventure seekers and nature lovers looking to explore underwater beauty."
  },
  {
    "title": "Murudeshwar Town",
    "description": "Murudeshwar is a peaceful coastal town that caters to pilgrims and tourists with accommodation, local eateries, and markets. The town offers fresh seafood, coastal Karnataka cuisine, and a relaxed atmosphere influenced by temple life and the sea."
  },
  {
    "title": "Festivals and Maha Shivratri Celebrations",
    "description": "Maha Shivratri is celebrated with great devotion in Murudeshwar, drawing thousands of pilgrims. The temple hosts special abhishekas, night-long prayers, and cultural programs. The festive energy combined with the coastal setting makes it a spiritually uplifting experience."
  },
  {
    "title": "Scenic Coastal Drive",
    "description": "The drive to Murudeshwar along the Konkan coastline is scenic and refreshing, passing through beaches, hills, and small coastal towns. This journey itself is considered a highlight for travelers, offering stunning views and peaceful moments."
  },
  {
    "title": "Spiritual and Tourism Blend",
    "description": "Murudeshwar uniquely blends devotion, mythology, architecture, and coastal beauty. It appeals to pilgrims seeking Lord Shiva’s blessings as well as tourists looking for scenic views and relaxation. The destination offers a complete experience of faith, nature, and tranquility."
  }
]
,



"services": [
{
"name": "Pune to Murudeshwar Bus On Rent Service",
"description": "Pune to Murudeshwar Bus On Rent Service provides dependable and comfortable bus rental solutions for travelers planning a spiritual and coastal journey to Murudeshwar. Ideal for families, devotees, and tour groups, this service offers well-maintained buses, spacious seating, and smooth long-distance travel. With experienced drivers and carefully planned routes, passengers can enjoy a safe, relaxed, and memorable journey from Pune to Murudeshwar."
},
{
"name": "Murudeshwar Bus Hire from Pune",
"description": "Murudeshwar Bus Hire from Pune offers organized and convenient transportation for temple visits and coastal tours. Designed for group travel, this service ensures timely departures, professional chauffeurs, and comfortable buses, making the long journey stress-free and well-coordinated."
},
{
"name": "AC Bus Pune to Murudeshwar",
"description": "AC Bus Pune to Murudeshwar ensures a comfortable and refreshing travel experience with fully air-conditioned buses. Perfect for long-distance journeys, summer travel, and family trips, these buses provide relaxed seating, smooth rides, and climate-controlled comfort throughout the journey."
},
{
"name": "Luxury Coastal Tour Bus",
"description": "Luxury Coastal Tour Bus delivers a premium travel experience with modern interiors, pushback seats, and enhanced onboard amenities. Ideal for VIP travelers, corporate groups, and special tours, this service combines comfort, safety, and elegance for a pleasant coastal travel experience."
},
{
"name": "Religious Tour Bus Murudeshwar",
"description": "Religious Tour Bus Murudeshwar is specially designed for devotees visiting the famous Murudeshwar temple. With disciplined drivers, comfortable buses, and organized travel plans, this service ensures a peaceful and spiritually focused journey."
},
{
"name": "Family Murudeshwar Trip",
"description": "Family Murudeshwar Trip bus services are tailored for families seeking safe, comfortable, and organized travel. Spacious seating, smooth driving, and reliable schedules ensure a pleasant journey for all age groups, making family temple visits stress-free."
},
{
"name": "Group Travel Murudeshwar Bus",
"description": "Group Travel Murudeshwar Bus provides efficient transportation for friends, religious groups, and tour operators. With high-capacity buses, experienced chauffeurs, and well-managed scheduling, this service ensures safe, comfortable, and coordinated group journeys."
},
{
"name": "Affordable Murudeshwar Bus Rental",
"description": "Affordable Murudeshwar Bus Rental offers budget-friendly bus rental options without compromising on safety or comfort. Ideal for devotees, families, and groups, this service provides transparent pricing, dependable buses, and professional drivers for economical long-distance travel."
},
{
"name": "Chauffeur Driven Bus Murudeshwar",
"description": "Chauffeur Driven Bus Murudeshwar ensures a hassle-free travel experience with skilled drivers managing highways, ghats, and long-distance routes. This service focuses on passenger safety, punctuality, and smooth driving for a relaxed temple and coastal journey."
},
{
"name": "Best Bus Service Pune to Murudeshwar",
"description": "Best Bus Service Pune to Murudeshwar is known for quality buses, reliable service, and customer satisfaction. Suitable for family trips, group travel, and religious tours, it prioritizes comfort, safety standards, and timely arrivals."
},
{
"name": "Pune Murudeshwar Travel Bus",
"description": "Pune Murudeshwar Travel Bus offers organized and dependable bus travel for devotees and tourists heading to Murudeshwar. With comfortable seating, experienced drivers, and well-planned routes, this service ensures a smooth and enjoyable journey."
},
{
"name": "Tourist Bus Murudeshwar",
"description": "Tourist Bus Murudeshwar caters to travelers exploring Murudeshwar and nearby coastal attractions. Flexible itineraries, comfortable buses, and professional drivers make sightseeing convenient and enjoyable for tourists and travel groups."
},
{
"name": "Outstation Bus Pune",
"description": "Outstation Bus Pune provides reliable long-distance bus services for interstate travel, including Karnataka coastal and temple tours. Well-maintained buses, trained drivers, and dependable scheduling ensure safe and comfortable extended journeys."
},
{
"name": "Online Bus Booking Murudeshwar",
"description": "Online Bus Booking Murudeshwar allows travelers to easily reserve buses with quick confirmation and flexible options. Multiple bus types, simple booking processes, and reliable service help plan Murudeshwar trips efficiently."
},
{
"name": "Karnataka Temple Tour Bus",
"description": "Karnataka Temple Tour Bus offers comprehensive bus travel solutions for visiting famous temples across Karnataka, including Murudeshwar. With comfortable buses, experienced chauffeurs, and organized itineraries, this service ensures a spiritually enriching and comfortable tour experience."
}
],
"tableData": [
["Pune to Murudeshwar Bus On Rent Service", "Murudeshwar Bus Hire from Pune"],
["AC Bus Pune to Murudeshwar", "Luxury Coastal Tour Bus"],
["Religious Tour Bus Murudeshwar", "Family Murudeshwar Trip"],
["Group Travel Murudeshwar Bus", "Affordable Murudeshwar Bus Rental"],
["Chauffeur Driven Bus Murudeshwar", "Best Bus Service Pune to Murudeshwar"],
["Pune Murudeshwar Travel Bus", "Tourist Bus Murudeshwar"],
["Outstation Bus Pune", "Online Bus Booking Murudeshwar"],
["Karnataka Temple Tour Bus", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Murudeshwar Bus On Rent Service with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers dependable and comfortable bus rental services from Pune to Murudeshwar, ideal for group tours, pilgrimages, family trips, and long-distance travel."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Buses",
    "WhyChoosedescription": "Our buses are clean, air-conditioned, and regularly serviced to ensure a smooth and enjoyable journey from Pune to Murudeshwar."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed and courteous drivers are familiar with long-distance routes like Pune to Murudeshwar, ensuring safe, timely, and stress-free travel for your group."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for Pune to Murudeshwar bus rentals, including fuel, tolls, and driver allowances — with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with bookings, travel queries, and itinerary planning for your long-distance trip."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized bus rental packages based on your group’s travel needs and schedule."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Murudeshwar bus rentals."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus on rent services from Pune to Murudeshwar?',
    answer: 'Yes, Sanavi Travels offers dependable and comfortable bus rental services from Pune to Murudeshwar for group travel and long-distance journeys.'
  },
  {
    question: 'How can I book a Pune to Murudeshwar bus?',
    answer: 'You can book a bus through our website or by contacting our 24x7 customer support team for assistance.'
  },
  {
    question: 'What types of buses are available for Pune to Murudeshwar trips?',
    answer: 'Sanavi Travels offers a range of buses including mini buses, 20-seater, 32-seater, 45-seater, and 50-seater options to suit your group size.'
  },
  {
    question: 'Are the drivers experienced with long-distance routes?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with long-distance routes like Pune to Murudeshwar, ensuring a safe and comfortable journey.'
  },
  {
    question: 'Can I customize my travel itinerary?',
    answer: 'Absolutely — you can customize pickup points, stops, and schedule according to your travel preferences.'
  },
  {
    question: 'Is the bus service available 24x7?',
    answer: 'Yes, Sanavi Travels offers round-the-clock support to help you plan and book your Pune to Murudeshwar bus rental.'
  },
  {
    question: 'Are the buses sanitized before the trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are available?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for your bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Pune to Murudeshwar bus trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohan Patil',
    feedback: 'Booked Pune to Murudeshwar bus rental with Sanavi Travels — very comfortable journey, clean bus, and professional driver!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Ayesha Kulkarni',
    feedback: 'Our trip from Pune to Murudeshwar was smooth and enjoyable thanks to Sanavi Travels — Excellent service and on-time arrival.',
    rating: 5
  }
];















































































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "BusTrip",
  "name": "Pune to Murudeshwar Bus On Rent Service - Sanavi Travels",
  "description": "Sanavi Travels provides Pune to Murudeshwar bus rental services with AC and luxury buses. Ideal for religious tours, Murudeshwar temple visits, family trips, and group travel. Affordable, chauffeur-driven buses with online booking.",
  "touristType": "Religious Tour, Pilgrimage, Family Trip, Group Travel, Temple Visit",
  "departureLocation": "Pune",
  "arrivalLocation": "Murudeshwar, Karnataka",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "25"
  }
};





  return (
    <div>
<Helmet>
  <title>
    Pune to Murudeshwar Bus On Rent Service | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Pune to Murudeshwar bus rental services by Sanavi Travels. AC and luxury buses for religious tours, Murudeshwar temple trips, family trips, and group travel. Affordable, chauffeur-driven, with online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/197.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomurudeshwarbusonrent;